module.exports = __webpack_public_path__ + "static/media/CheckboxIntermediate.651fe8d1.svg";